/*签约单位*/
import { $http, buildHeaders } from "./index";

//获取签约单位列表
export const contractunit_list = (params) => {
  return $http.get("/admin/ContractUnit/index", { params });
};

//获取签约单位详情
export const contractunit_detail = (id) => {
  return $http.get("/admin/ContractUnit/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取签约单位下拉数据
export const contractunit_select = () => {
  return $http.get("/admin/ContractUnit/index", {
    params: { limit: 0, sort_field: "name", status: 1 },
  });
};

//添加签约单位
export const contractunit_add = (data) => {
  return $http.post("/admin/ContractUnit/add", data, {
    headers: buildHeaders(3),
  });
};

//修改签约单位
export const contractunit_edit = (data) => {
  return $http.post("/admin/ContractUnit/edit", data, {
    headers: buildHeaders(3),
  });
};

//删除签约单位
export const contractunit_delete = (id) => {
  return $http.post(
    "/admin/ContractUnit/del",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};
